import { render, staticRenderFns } from "./VideoRecordingPoC.vue?vue&type=template&id=0cdbfce1&"
import script from "./VideoRecordingPoC.vue?vue&type=script&lang=js&"
export * from "./VideoRecordingPoC.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecordingPoC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports